export const educationData = [
    {
        id: 1,
        institution: '',
        course: 'Keble College International School',
        startYear: '2013',
        endYear: '2016'
    },
    {
        id: 2,
        institution: "",
        course: "President's College - Maharagama",
        startYear: '2016',
        endYear: '2017'
    },
    {
        id: 3,
        institution: '',
        course: 'Meepawala Amarasuriya College - Galle',
        startYear: '2017',
        endYear: '2018'
    },
    {
        id: 4,
        institution: 'High-School',
        course: 'Dharmapala Vidyalaya - Pannipitiya',
        startYear: '2018',
        endYear: '2025'
    },
    {
        id: 5,
        institution: 'University',
        course: 'SLIIT CITY UNI - Colombo',
        startYear: '2025',
        endYear: 'Present'
    },
]